module.exports = __webpack_public_path__ + "static/media/notosans-regular-webfont.99226c29.woff";


//////////////////
// WEBPACK FOOTER
// ./src/vendor/fonts/notosans-regular-webfont.woff
// module id = 1519
// module chunks = 0